import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ScoreDescription } from '@wilson/shift/core';
import { ScoreBarComponent } from '../score-bar/score-bar.component';

@Component({
  selector: 'wilson-score-display',
  templateUrl: './score-display.component.html',
  styleUrls: ['./score-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScoreBarComponent],
})
export class ScoreDisplayComponent {
  @Input() score!: ScoreDescription;
}
